import { ActionTree } from 'vuex';
import { PostGradMicrocertificateState } from './state';
import RootState from '@/store/root_state';
import MicrocertificateRequestsService from '@/helpers/postgradMicrocertificate/request';
import { getDexToken } from '@/helpers/get-tokens';

const actions: ActionTree<PostGradMicrocertificateState, RootState> = {
  async GET_DISCIPLINE_MICROCERTIFICATE_ELIGIBILITY({ getters, commit }, classroomId: number) {
    const token = getDexToken();
    const course = getters.currentCourse;
    if (!token) return;
    const eligibility = await MicrocertificateRequestsService.getMicrocertificateEligibility({
      classroomId,
      course,
      token,
    });
    commit('SET_POSTGRAD_MICROCERTIFICATE_ELIGIBILITY', {
      classroomId,
      disciplinesMicrocertificateEligibility: eligibility,
    });
  },
};

export default actions;
